import { useLocation, useNavigate } from 'react-router-dom';
import { FaBars, FaSignOutAlt, FaUserCircle } from 'react-icons/fa';
import { logout } from '../services/authService';

const TITLES = [
  ['/dashboard', 'Dashboard'],
  ['/users', 'Users'],
  ['/admin/users', 'User Details'],
  ['/orders', 'Orders'],
  ['/coins-history', 'Points History'],
  ['/internal-users', 'Internal Users'],
  ['/notifications', 'Notifications'],
  ['/promotions', 'Promotions'],
  ['/coupons', 'Coupons'],
  ['/banners', 'Banner Images'],
  ['/settings/points-rules', 'Points Rules'],
  ['/settings/general', 'General Settings'],
  ['/settings/delivery-locations', 'Delivery Locations'],
  ['/settings/app-version', 'App Version'],
];

function titleFor(pathname) {
  const match = TITLES.find(([p]) => pathname === p || pathname.startsWith(p + '/'));
  return match ? match[1] : 'Dashboard';
}

export default function Topbar({ onMenuClick }) {
  const location = useLocation();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  return (
    <header className="sticky top-0 z-20 flex h-16 items-center gap-3 border-b border-slate-200 bg-white/80 px-4 backdrop-blur md:px-6">
      <button
        type="button"
        onClick={onMenuClick}
        className="flex h-9 w-9 items-center justify-center rounded-lg text-slate-600 hover:bg-slate-100 lg:hidden"
        aria-label="Open menu"
      >
        <FaBars />
      </button>

      <h1 className="ui-page-title truncate">{titleFor(location.pathname)}</h1>

      <div className="ml-auto flex items-center gap-3">
        <div className="hidden items-center gap-2 rounded-lg border border-slate-200 bg-white px-3 py-1.5 sm:flex">
          <FaUserCircle className="text-lg text-slate-400" />
          <span className="text-sm font-medium text-slate-700">Admin</span>
        </div>
        <button
          type="button"
          onClick={handleLogout}
          className="ui-btn-ghost"
          title="Sign out"
        >
          <FaSignOutAlt />
          <span className="hidden sm:inline">Sign out</span>
        </button>
      </div>
    </header>
  );
}
